<template>
<div v-loading="loading" class="content-two">
  <div class="video_content" style="width: 100%"  v-infinite-scroll="load">
    <div
      class="video_item"
      @click="lookVideo(item.videoUri)"
      v-for="(item, index) in videoList"
      :key="index"
    >
      <em class="iconfont iconplay"></em>
      <video
        :src="item.videoUri"
        :poster="
          item.videoUri +
          '?x-oss-process=video/snapshot,t_1000,f_jpg,w_750,m_fast'
        "
        preload="none"
      ></video>
      <div class="dec">
        <span class="name">{{ item.userName }}</span>
        <span class="universityName">{{ item.logTitle }}</span>
        <img alt="" :src="item.login + '?x-oss-process=style/log_list_thumb'" />
      </div>
    </div>
    <div class="shade_pop animate__animated animate__fadeIn" v-if="modal"></div>
    <div class="log_modal" v-if="videoModal" @click="closevideo">
      <img
        class="log_close"
        src="https://univteam-imageserver.oss-cn-qingdao.aliyuncs.com/ClassMS/Images/202110291045042331.svg"
        alt=""
      />
      <video
        class="look_img"
        controls="controls"
        :src="look_video"
        ref="videoPlayer"
        alt=""
      ></video>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      modal: false,
      videoModal: false,
      videoUri: "",
      id: "",
      tagId: "",
      videoList: [],
      look_video:'',
      count:1,
      loading: false,
    };
  },
  created() {
    this.id = this.$route.query.ppcId;
    this.tagId = this.$route.query.tagId;
    this.getVideoList();
  },
  methods: {
    load() {
        this.loading = true;
        setTimeout(() => {
          this.count += 1; //页数+1
          this.getVideoList(); //调用接口，此时页数+1，查询下一页数据
        }, 2000);
    },
    getVideoList() {
      var data = {
        pageSize: 15,
        pageIndex: this.count,
        id: this.id,
        tagId: this.tagId,
      };
      this.$api.social.getLogVideo(data).then((res) => {
        console.log(res);
        this.loading = false;
        if (res.data.length > 0) {
          this.videoList = this.videoList.concat(res.data);
        }
      });
    },
    closevideo() {
      this.modal = false;
      this.videoModal = false;
    },
    lookVideo(item) {
      this.videoModal = true;
      this.modal = true;
      this.look_video = item;
    },
  },
};
</script>

<style lang="scss" scoped>
.video_content {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  max-height: 800px;
  overflow: auto;
  padding-right: 10px;
  .video_item {
    width: 301px;
    height: 180px;
    position: relative;
    cursor: pointer;
    overflow: hidden;
    margin-bottom: 15px;
    img {
      width: 100%;
      object-fit: cover;
    }
    .dec {
      position: absolute;
      bottom: 0px;
      height: 66px;
      width: 100%;
      background: linear-gradient(rgba(50, 54, 70, 0), rgba(28, 31, 48, 1));
      color: #ffffff;
      font-size: 14px;
      padding: 24px 10px 0 10px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
    em.iconfont.iconplay {
      position: absolute;
      z-index: 99;
      font-size: 57px;
      color: #fff;
      opacity: 0.8;
      left: 41.5%;
      top: 34%;
    }
    video {
      width: 100%;
      margin-left: 0.3%;
      object-fit: cover;
      height: 270px;
    }
  }
  .video_item:nth-last-of-type(-n+3){
    margin-bottom: 0;
  }
}
.shade_pop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}
.log_modal {
  width: 860px;
  // height: 710px;
  border-radius: 10px;
  position: fixed;
  top: 13%;
  left: 50%;
  margin-left: -500px;
  // margin-top: -355px;
  background: #fff;
  z-index: 1001;
  padding: 20px;
  .log_close {
    width: 40px;
    position: absolute;
    top: -60px;
    right: 20px;
    cursor: pointer;
  }
  .look_img {
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    max-height: 800px;
  }
}
video::-webkit-media-controls-fullscreen-button {
  display: none;
}
video::-webkit-media-controls-mute-button {
  display: none !important;
}
video::-internal-media-controls-overflow-button {
  display: none !important;
}
// ::-webkit-scrollbar {
//   /*滚动条整体样式*/
//   width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
//   height: 30px;
// }
// ::-webkit-scrollbar-track {
//   -webkit-box-shadow: inherit;
//   border-radius: 0;
//   background: inherit;
// }
// ::-webkit-scrollbar-thumb {
//   border-radius: inherit;
//   -webkit-box-shadow: inherit;
//   background: rgba(83, 144, 232, 0.5);
// }
</style>